const SUPERSCRIPT: Record<string, string> = {
    0:'⁰',1:'¹',2:'²',3:'³',4:'⁴',5:'⁵',6:'⁶',7:'⁷',8:'⁸',9:'⁹',
    a:'ᵃ',b:'ᵇ',c:'ᶜ',d:'ᵈ',e:'ᵉ',f:'ᶠ',g:'ᵍ',h:'ʰ',i:'ⁱ',j:'ʲ',
    k:'ᵏ',l:'ˡ',m:'ᵐ',n:'ⁿ',o:'ᵒ',p:'ᵖ',r:'ʳ',s:'ˢ',t:'ᵗ',u:'ᵘ',
    v:'ᵛ',w:'ʷ',x:'ˣ',y:'ʸ',z:'ᶻ','+':'⁺','-':'⁻','=':'⁼','(':'⁽',')':'⁾'
};

const SUBSCRIPT: Record<string, string> = {
    0:'₀',1:'₁',2:'₂',3:'₃',4:'₄',5:'₅',6:'₆',7:'₇',8:'₈',9:'₉',
    a:'ₐ',e:'ₑ',o:'ₒ',x:'ₓ',h:'ₕ',i:'ᵢ',k:'ₖ',l:'ₗ',m:'ₘ',n:'ₙ',p:'ₚ',
    r:'ᵣ',s:'ₛ',t:'ₜ',u:'ᵤ',v:'ᵥ','+':'₊','-':'₋','=':'₌','(':'₍',')':'₎'
};

const convert = (map: Record<string, string>) => (content: string) =>
    content.split('').map(c => map[c] ?? '').join('');

export function stripHtml(value: string): string {
    return value.toString()
        .replace(/<sup>(.*?)<\/sup>/g, (_, c) => convert(SUPERSCRIPT)(c))
        .replace(/<sub>(.*?)<\/sub>/g, (_, c) => convert(SUBSCRIPT)(c))
        .replace(/<[^>]*>/g, '');
}
